import { INTEGRATION_TYPE } from "@/Pages/Integrations/types";
import { ROUTES } from "@/shared";
import { useIntegrationsDialogStore } from "@/stores/useIntegrationsDialogStore";

import PageHeaderActions from "../PageHeaderActions";

const IntegrationsHeaderActions = () => {
  const { openAddDialog } = useIntegrationsDialogStore();

  return (
    <PageHeaderActions
      route={ROUTES.Integrations}
      openDialog={() => openAddDialog(INTEGRATION_TYPE.Sftp)}
      addItem
    >
      <></>
    </PageHeaderActions>
  );
};

export default IntegrationsHeaderActions;
